// src/components/Navbars/InfoNavbar.jsx
import React from "react";
import { Box, Container, useTheme, useMediaQuery } from "@mui/material";
import tokaiLogo from "../../assets/tokai-images/logos/tokaiLogo.png";

export default function InfoNavbar() {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const items = [
    ["idx176", "1.76 Index"],
    ["progressive", "Progressive"],
    ["single-vision", isMobile ? "SV" : "Single vision"],
    ["photochromic", "Photochromic"],
    ["coatings", "Coatings"],
  ];


  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <Box
      className="tokai-navbar"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        backgroundColor: "#fff",
        boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            minHeight: { xs: 120, md: 92 },
            py: { xs: 2, md: 0 },

            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            component="img"
            src={tokaiLogo}
            alt="TOKAI"
            sx={{
              height: 48,
              width: "auto",
              display: { xs: "none", md: "block" }, // 👈 hide on mobile
            }}
          />


          {/* ✅ mobile: horizontal scroll, desktop: wrap */}
          <Box
            sx={{
              display: "flex",
              gap: 1.5,
              flexWrap: "wrap",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {items.map(([id, label]) => (
              <Box
                key={id}
                onClick={() => scrollTo(id)}
                sx={{
                  cursor: "pointer",
                  px: 2,
                  py: 0.8,
                  borderRadius: "999px",
                  fontSize: "0.9rem",
                  backgroundColor: "#f3f5f7",
                  userSelect: "none",

                  // 👇 force clean 2-row structure
                  flexBasis: { xs: "30%", md: "auto" },
                  textAlign: "center",

                  "&:hover": { backgroundColor: "#e9eef2" },
                }}
              >
                {label}
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
